app.service('basketAnalytics', function (pageConfig, log) {

	function setProductData(product, productIndexInCart) {
		var productData = {
			index: productIndexInCart, //Który na liście był produkt dla którego dodano gwarancję/usługę
			dimension47: product.isInstalmentPrice ? "Raty" : "Gotówka", //Informacja czy produkt jest w Ratach czy za Gotówkę
		}
		if (product.nodes) {
			if (product.nodes[0]) {
				productData.item_category = product.nodes[0].name; //Kategoria produktu dla jakiego jest dodawana gwarancja/usługa 
				if (product.nodes[1]) {
					productData.item_category2 = product.nodes[1].name; //Kategoria 2 produktu dla jakiego jest dodawana gwarancja/usługa
					if (product.nodes[2]) {
						productData.item_category3 = product.nodes[2].name; //Kategoria 3 produktu dla jakiego jest dodawana gwarancja/usługa  
					}
				}
			}
		}
		return productData;
	}
	function sendWarrantyAndServicesUA() {
		var basket = pageConfig.getData('basket');
		var data = [];
		var basketItemsArray = basket.items;
		if (basketItemsArray.length) {
			basketItemsArray.forEach((product, i) => {
				var productData = setProductData(product, i);
				var warranty = product.warranty && product.warranty.length ? product.warranty[0] : false;
				if (warranty) {
					data.push($.extend({
						item_name: warranty.name, //Nazwa grawancji
						price: warranty.price, //Cena grawancji
						item_id: warranty.id, //ID grawancji
						item_list_id: 'Koszyk', //Miejsce dodania do koszyka 
						item_list_name: 'Koszyk - Ubezpieczenia', //Szczegółowe miejsce dodania do koszyka
						item_variant: warranty.type, //Wariant grawancji
						quantity: warranty.quantity, //Ilość grawancji
						dimension31: 'Ubezpieczenie', //Kategoria dodawanego elementu
					}, productData));
				}
				var services = product.services || [];
				if (services.length) {
					services.forEach((service, j) => {
						data.push($.extend({
							item_name: service.name, //Nazwa usługi
							price: service.price, //Cena usługi
							item_id: service.id, //ID usługi
							item_list_id: 'Koszyk', //Miejsce dodania do koszyka 
							item_list_name: 'Koszyk - Usługi', //Szczegółowe miejsce dodania do koszyka
							item_variant: service.name, //Wariant usługi
							quantity: service.quantity, //Ilość usług
							dimension31: 'Usługa', //Kategoria dodawanego elementu
						}, productData));
					})
				}
				var partnerSubscriptions = product.partnerSubscriptions || [];
				if (partnerSubscriptions.length) {
					partnerSubscriptions.forEach((partnerSubscription, k) => {
						data.push($.extend({
							item_name: partnerSubscription.name, //Nazwa usługi
							price: partnerSubscription.price, //Cena usługi
							item_id: partnerSubscription.id, //ID usługi
							item_list_id: 'Koszyk', //Miejsce dodania do koszyka 
							item_list_name: 'Koszyk - Usługi partnerskie', //Szczegółowe miejsce dodania do koszyka
							item_variant: partnerSubscription.name, //Wariant usługi
							quantity: partnerSubscription.quantity, //Ilość usług
							dimension31: 'Usługa partnerska', //Kategoria dodawanego elementu: usługa
						}, productData));
					});
				}
			})
			if (data.length) {
				UA.push({
					event: "add_to_cart",
					ecommerce: {
						items: [
							data
						]
					}
				});
			}
		}
	}

	function removeItem(itemId, quantity = 1){
		console.log('odejmowanie', itemId, quantity);
		let items = pageConfig.getData('basket').items;
		let productInfo = items.filter( (e) => e.cartId === itemId )[0];
		if(productInfo){
			for(let i = 1; i <= quantity ; i++ ){
				log.event({
					id: 'remove_cart',
					f03: 'cart_step_1',
					f04: productInfo.plu,
					f05: 'product',
					f06: '',
					f07: 'leaf',
					f08: 'button',
					f09: productInfo.isOutlet ? 'outlet' : 'new',
					f10: productInfo.isInstalmentPrice ? 'installment' : 'cash',
					f11: productInfo.packageCode ? productInfo.packageCode : ''
				});
				if(productInfo.packageCode){
					items.filter( (e) => e.packageCode === productInfo.packageCode && e.id != productInfo.id).forEach(suiteInfo => {
						log.event({
							id: 'remove_cart',
							f03: 'cart_step_1',
							f04: suiteInfo.plu,
							f05: 'akc',
							f06: productInfo.plu,
							f07: 'leaf',
							f08: 'button',
							f09: suiteInfo.isOutlet ? 'outlet' : 'new',
							f10: suiteInfo.isInstalmentPrice ? 'installment' : 'cash',
							f11: productInfo.packageCode
						});
					});
				}
			}
		}
	}

	function addItem(itemId, quantity=1){
		console.log('dodawanie', itemId, quantity);
		let items = pageConfig.getData('basket').items;
		let productInfo = items.filter( (e) => e.cartId === itemId )[0];
		if(productInfo){
			for(let i = 1; i <= quantity ; i++ ){
				log.event({
					id: 'to_cart',
					f03: 'cart_step_1',
					f04: productInfo.plu,
					f05: 'product',
					f06: '',
					f07: 'leaf',
					f08: 'button',
					f09: productInfo.isOutlet ? 'outlet' : 'new',
					f10: productInfo.isInstalmentPrice ? 'installment' : 'cash',
					f11: productInfo.packageCode ? productInfo.packageCode : ''
				});
				if(productInfo.packageCode){
					items.filter( (e) => e.packageCode === productInfo.packageCode && e.id != productInfo.id).forEach(suiteInfo => {
						log.event({
							id: 'to_cart',
							f03: 'cart_step_1',
							f04: suiteInfo.plu,
							f05: 'akc',
							f06: productInfo.plu,
							f07: 'leaf',
							f08: 'button',
							f09: suiteInfo.isOutlet ? 'outlet' : 'new',
							f10: suiteInfo.isInstalmentPrice ? 'installment' : 'cash',
							f11: productInfo.packageCode
						});
					});
				}
			}
		}
	}
	function changeQuantity(itemId, quantity = 1){
		var basket = pageConfig.getData('basket');
		let basketItem = basket.items.filter((i) => i.cartId == itemId);
		if(basketItem && basketItem.length){
			if(quantity > basketItem[0].quantity){
				addItem(itemId, quantity - basketItem[0].quantity);
			}else {
				removeItem(itemId, basketItem[0].quantity - quantity);
			}
		} else {
			console.log('Brak itema w koszyku');
		}
	}


	return {
		sendWarrantyAndServicesUA, changeQuantity, removeItem
	};
});
